import { LazyLoadedStatesManager } from '../class/lazy-loaded-states-manager.class';
import { LazyLoadedStates } from '../interfaces/lazy-loaded-states.interface';

export const AssignmentsLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    view: LazyLoadedStates,
    bulkAssign: LazyLoadedStates
}>({
    base: {
        name: 'authenticated.assignments',
        url: '/assignments',
    },
    view: {
        name: 'authenticated.assignments.view',
        url: '/view?page&userType&bid&searchBy&isSupervisorOnly&pageSize'
    },
    bulkAssign: {
        name: 'authenticated.assignments.bulkAssign',
        url: '/bulkAssign'
    }
},
    () => import('src/app/assignments/assignments.module').then(mod => mod.AssignmentsModule)
);
